import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cookies",
  "description": "",
  "published": "2006-12-25T00:00:00.000Z",
  "redirect_from": ["/blog/cookies/swizec/344"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So it's christmas or some other very important consumerist holiday of some expensive sort, and so what. Everyone does christmas blogs or comics or even both and it's all rather turned into some shit nobody really cares about anymore, at least nobody older than twelve.`}</p>
    <p>{`So I decided to do this a bit differently, I will talk to you about the evil that are cookies. Yes, I have meant for this little chat with a brick wall to take place a while ago, but alas it simply did not. Cookies, they are a vile species of, whatever the hell they are. I am almost certain they come from some unrully galaxy far far away and have infested our brain with little virii that make us produce more and more of the evil beings. Acording to my observation they spread by being eaten alive, which invariably produces a desire to eat more. In time this evil need consumes the whole victim until it is consumed so much it starts producing more cookies.`}</p>
    <p>{`When enough time will pass I am certain cookies will take over the world and create a colony that will slowly infest venus or wherever the rest of humanity has run off to and eventually there will be no more space, just a giant crumbly delicious cookie.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      